module.exports = __webpack_public_path__ + "img/icon13.1918acc4.svg";